import styled from 'styled-components'

export const RadioInput = styled.span`
  input[type='radio'] {
    &:checked {
      accent-color: var(--color-primary);
    }
  }
`
